import {DateTime} from 'luxon';
import {isKeyOf} from 'libs/shared/util/src/lib/_helpers/isKeyOf';

export function generateHumanizedDate(date: DateTime): string {
    const dateDiff = DateTime.local().diff(date, ['years', 'months', 'days', 'hours', 'minutes', 'seconds']).toObject();
    const timeIntervals = {
        years: 'year',
        months: 'month',
        days: 'day',
        hours: 'hour',
        minutes: 'minute'
    };

    for (const [interval, unit] of Object.entries(timeIntervals)) {
        if (isKeyOf(interval, dateDiff) && dateDiff[interval] > 0) {
            return `${dateDiff[interval]} ${unit}${dateDiff[interval] > 1 ? 's' : ''} ago`;
        }
    }

    return 'few seconds ago';
}
